import { useCallback } from 'react';

import { useSearchResultsPageContext } from '../../contexts/SearchResultsPageContext';
import { useVendorGridCards } from '../../contexts/VendorGridCardsContext';
import { useVendorSearchNavigation } from '../../contexts/VendorSearchNavigationContext';
import { VendorSearchResults } from '../VendorSearchResults/VendorSearchResults';

export const VendorSearchResultsGrid = () => {
  const { vendorOrQuizCardViews: searchResults } = useVendorGridCards();
  const { loading } = useSearchResultsPageContext();

  const { navigateToSrp } = useVendorSearchNavigation();

  const clearFilters = useCallback(() => {
    navigateToSrp({
      awardGroups: null,
      selectedFacets: null,
      price: null,
      capacity: null,
      searchTerm: null,
      availabilityDates: null,
      metroTypes: null,
      catererTypes: null,
      page: undefined,
    });
  }, [navigateToSrp]);

  return (
    <VendorSearchResults
      searchResults={searchResults}
      isLoading={loading}
      handleClearFilters={clearFilters}
    />
  );
};
